<div *ngIf="newPayment; else notNewPayment">
  <!-- <pme-mobile-dropdown> -->
  <div content>
    <mat-card class="pme-new-cart-card">
      <mat-card-content>
        <div class="invoice-container">
          <div class="details">
            <p title class="color-blue">
              {{
              this.bankBilletData || (!this.isPixPaid && this.pixData)
              ? "Resumo do pedido"
              : "Detalhes do pedido"
              }}
            </p>
            <mat-divider inset></mat-divider>
            <div class="product-details-container">
              <b class="color-diff-blue product-name">{{
                contract.product.classificationName
                }}</b>
              <div class="product-choice-info">
                <p class="font-size-14 color-diff-blue">
                  {{
                  contract.product.classificationIdentifier ===
                  "consulta-e-recuperacao-de-dividas"
                  ? "Pacote de créditos"
                  : getPlanType()
                  }}
                </p>
              </div>
              <div class="product-choice-price color-diff-blue">
                <b> {{ invoiceSubtotal | currency:'R$' }} </b>
              </div>
            </div>
            <mat-divider inset></mat-divider>
            <div *ngIf="contract.endDate && !contract.trialData" class="validity">
              <p>Vigência:</p>
              <span class="date">{{ contract.endDate }}</span>
            </div>
            <div class="discount-description"
              *ngIf="(bankBilletData || (pixData && !this.isPixPaid) && !creditCardData) || (!finalBalanceTrust)">
              <!-- Descontos convencionais -->
              <div class="discount-description-price">
                <p id="color-diff-blue" class="font-size-16">
                  Subtotal
                </p>
                <ng-template #singleDiscount>
                  <p id="color-diff-blue" class="font-size-16">Subtotal</p>
                </ng-template>
                <div>
                  <li class="display-utils-row display-utils-between-center display-utils-gap-8">
                    <b id="color-blue-coupon">
                      {{ invoiceSubtotal | currency: "R$" }}
                    </b>
                  </li>
                </div>
              </div>

              <div class="discount-description-price" *ngIf="
                  !contract.trialData &&
                  appliedCoupons &&
                  appliedCoupons.length > 0
                ">
                <p class="color-diff-blue" class="font-size-16" *ngIf="appliedCoupons.length > 1; else singleDiscount">
                  Descontos
                </p>
                <ng-template #singleDiscount>
                  <p id="color-diff-blue" class="font-size-16">Desconto</p>
                </ng-template>
                <div>
                  <li class="display-utils-row display-utils-between-center display-utils-gap-8">
                    <b class="color-purple-coupon">
                      {{ invoiceDiscount | currency: "R$" }}
                    </b>
                  </li>
                </div>
              </div>
              <p class="totalPayment" *ngIf="!this.contract.trialData">Total a pagar</p>
              <div>
                <div class="discount-description-price" *ngIf="extraBalanceCoupon && extraBalanceCoupon.length > 0">
                  <p class="color-diff-blue" class="font-size-16">Bônus</p>
                  <div>
                    <li class="display-utils-row display-utils-between-center display-utils-gap-8"
                      *ngFor="let discount of extraBalanceCoupon">
                      <b id="color-green-coupon">{{
                        discount.totalCredit - contract.product.value
                        | currency: "+R$"
                        }}</b>
                    </li>
                  </div>
                </div>
              </div>
              <mat-divider inset></mat-divider>
            </div>
            <!-- Total -->
            <div class="pme-cart-total color-blue">
              <div class="pme-cart-total-content"
                *ngIf="(bankBilletData || (pixData && !this.isPixPaid) && !creditCardData) || (!finalBalanceTrust)">
                <div *ngIf="this.contract.trialData">
                  <p>
                    <span>Total a pagar após</span><br />
                    <b class="color-blue-coupon">{{ this.paidValueMessage }}</b>
                  </p>
                </div>
                <p class="totalPayment">Total a pagar</p>
                <div>
                  <span>
                    <b id="currency">R$ </b>
                    <span *ngIf="!this.contract.trialData">
                      <!-- Cartão de crédito -->
                      <b *ngIf="creditCardData" id="main-value">{{
                        creditCardData.totalValue.toString().split(".")[0]
                        }}</b>
                      <b *ngIf="creditCardData" id="cents">,{{
                        creditCardData.totalValue.toString().split(".")[1]
                        }}</b>
                      <!-- Boleto bancário -->
                      <b *ngIf="bankBilletData" id="main-value">{{
                        bankBilletData.totalValue.toString().split(".")[0]
                        }}</b>
                      <b *ngIf="bankBilletData" id="cents">,{{
                        bankBilletData.totalValue.toString().split(".")[1]
                        }}</b>
                      <!-- PIX -->
                      <b *ngIf="pixData" id="main-value">{{
                        pixData.totalValue.toString().split(".")[0]
                        }}</b>
                      <b *ngIf="pixData" id="cents">,{{ pixData.totalValue.toString().split(".")[1] }}</b>
                    </span>
                    <b *ngIf="contract && contract.trialData && contract.product" id="main-value">{{
                      contract.product.value.toString().split(".")[0] }}</b>
                    <b *ngIf="contract && contract.trialData && contract.product" id="cents">,{{
                      contract.product.value
                      .toFixed(2)
                      .toString()
                      .split(".")[1]
                      }}</b>
                  </span>
                </div>

              </div>
              <div *ngIf="finalBalanceTrust && ((this.pixData && this.isPixPaid) || creditCardData)">
                <div class="finalBalanceTrust">
                  <div class="discountTrust">
                    <p>Desconto das consultas realizadas</p>
                    <span>
                      <b class="color-red">{{(totalDebitTrust) | currency: "-R$" }}</b>
                    </span>
                  </div>
                  <div class="creditTrust">
                    <p> Créditos adicionados </p>
                    <span>
                      <b id="main-value">{{ finalBalanceTrust | currency: "R$"}}</b>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="!this.contract.trialData">
              <!-- Cartão de crédito -->
              <div *ngIf="creditCardData && creditCardData.totalValue != 0" class="payment-method">
                <div class="payment">
                  <div class="payment-info">
                    <img id="cardLogo" src="/assets/images/payment-methods/{{
                        this.creditCardData.getBrandCSSMatching()
                      }}.png" />
                    <div class="payment-info-text">
                      <p class="font-size-16-weight700 color-blue">
                        Final {{ getLastCreditCardNumbers() }}
                      </p>
                      <p class="color-blue">
                        {{
                        calculateInstallments() > 1
                        ? "Parcelado em"
                        : "À vista "
                        }}{{ calculateInstallments() }}x
                        {{ valueOfInstallments() | currency: "R$" }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Boleto -->
              <div *ngIf="bankBilletData && bankBilletData.totalValue != 0" class="payment-method">
                <div class="payment">
                  <div class="payment-info">
                    <img id="billet" src="/assets/images/payment-methods/billetCheckout.png" />
                    <div class="paymentCheckoutContainer">
                      <b>Boleto bancário</b>
                      <p>Aguardando pagamento.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div [ngClass]="{ messageInfo: this.bankBilletData }" *ngIf="bankBilletData">
                <!-- <div [ngClass]="{'messageInfo': this.cardNumberisFocused || this.cardNumberHasValue}"></div>> -->

                <div class="info-message-text" *ngIf="contract.product.hasBalance">
                  <pme-info-message type="new-info">
                    <div
                      *ngIf="(finalBalanceTrust && finalBalanceTrust !== 0) || (extraBalanceSum && extraBalanceSum !== 0); else noCoupon">
                      <p>
                        <strong>
                          {{
                          (finalBalanceTrust || contract.product.value + extraBalanceSum)
                          | currency: 'R$'
                          }}
                        </strong>
                        serão adicionados ao seus créditos.
                      </p>
                    </div>

                    <ng-template #noCoupon>
                      <p>
                        <strong>
                          {{
                          contract.product.value
                          | currency: 'R$'
                          }}
                        </strong>
                        serão adicionados ao seus créditos.
                      </p>
                    </ng-template>
                  </pme-info-message>
                </div>
              </div>
              <!-- PIX -->
              <div *ngIf="pixData" class="payment-method">
                <div class="payment">
                  <div class="payment-info">
                    <img id="pix" src="/assets/images/payment-methods/pixCheckout.png" />
                    <div class="paymentCheckoutContainer">
                      <b>PIX</b>
                      <p *ngIf="this.isPixPaid">Pagamento confirmado</p>
                      <p *ngIf="!this.isPixPaid">Aguardando pagamento</p>
                    </div>
                  </div>
                </div>
                <div class="info-message-text" *ngIf="contract.product.hasBalance">

                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Cartão de crédito -->
        <div *ngIf="this.contract.trialData" class="payment-method">
          <b class="color-blue">Forma de pagamento</b>
          <div class="payment">
            <div class="payment-info">
              <img id="cardLogo" src="/assets/images/payment-methods/{{
                  this.creditCard.getBrandCSSMatching()
                }}.png" />
              <p>Final</p>
              <p>{{ getLastCreditCardNumbers() }}</p>
            </div>
            <div>
              <p>
                {{ calculateInstallments() }}x
                {{ valueOfInstallments() | currency: "R$" }}
              </p>
            </div>
          </div>
        </div>

        <div class="automatic-recharge-info" *ngIf="
            this.contract.product.classificationIdentifier ===
              'consulta-e-recuperacao-de-dividas' &&
            this.contract.provisioningParameters.allowAutomaticRecharge
          ">
          <mat-card>
            <mat-card-content>
              <b>Recarga Garantida Ativada</b>
              <p>
                Sua Recarga Garantida foi ativada e uma nova compra automática
                de R$ {{ invoiceSubtotal }} será
                realizada em seu cartão sempre que seu crédito for
                igual ou menor que R$ {{ automaticRechargeValueFormat() }}. Para
                desativar/reativar essa função a qualquer momento, basta acessar
                a
                <a href="https://www.serasaempreendedor.com.br/auto-servico/meus-dados">Central do Usuário</a>.
              </p>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <!-- </pme-mobile-dropdown> -->
</div>

<ng-template #notNewPayment>
  <div *ngIf="this.isInvestigate">
    <div class="bpo-analysis">
      <mat-card>
        <!-- MODAL 1 -->
        <mat-card-content *ngIf="!this.modalParams.walletBalance">
          <div class="pme-order-info display-utils-col display-utils-gap-4">
            <div *ngIf="this.contract && this.showProduct">
              <span>Produto: </span> {{ this.contract.product.name }}
            </div>

            <div *ngIf="this.contract && this.contract.code">
              <span>Pedido: </span>{{ this.contract.code }}
            </div>

            <div *ngIf="this.totalValue">
              <span>Valor: </span>{{ totalValue < 0 ? "0,00" : (totalValue | currency: "R$" ) }} </div>
            </div>
            <mat-divider inset></mat-divider>
        </mat-card-content>

        <!-- MODAL 2 -->
        <mat-card-content *ngIf="this.modalParams.walletBalance">
          <div class="pme-order-info display-utils-col display-utils-gap-4">
            <div *ngIf="this.contract && this.contract.code">
              <span>Pedido: </span>{{ this.contract.code }}
            </div>

            <div>
              <span>Crédito: </span>{{ this.modalParams.walletBalance | currency: "R$" }}
            </div>

            <div *ngIf="this.contract && this.contract.saleDate">
              <span>Data da compra: </span>{{ this.contract.saleDate }}
            </div>

            <div *ngIf="this.bankBilletData">
              <span>Forma de pagamento: </span> Boleto
            </div>

            <div *ngIf="this.pixData">
              <span>Forma de pagamento: </span> PIX
            </div>

            <div *ngIf="this.creditCardData">
              <span>Forma de pagamento: </span> Cartão
            </div>
          </div>
        </mat-card-content>
        <mat-card-content>
          <div class="mat-card-investigate">
            <p>Falta pouco para ter acesso ao seu novo crédito!</p>
            <b>Recebemos seu pedido e logo confirmaremos sua compra!</b>

            <p>
              Para maior segurança, alguns pedidos passam por um processo de
              confirmação de dados, mas não se preocupe, o prazo máximo para
              conclusão é de até 6 horas.
            </p>
            <br />
            <p>Te avisaremos por e-mail assim que o status for atualizado :)</p>
            <p>
              * Em casos excepcionais, pode haver a necessidade de um tempo
              maior para a conclusão do processo de confirmação de dados.
            </p>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div *ngIf="!this.isInvestigate">
    <mat-card>
      <!-- MODAL 1 -->
      <mat-card-content *ngIf="!this.modalParams.walletBalance">
        <div class="pme-order-info display-utils-col display-utils-gap-4">
          <div *ngIf="this.contract && this.showPlan">
            <span>Plano: </span> {{ this.contract.product.name }}
          </div>
          <div *ngIf="this.contract && this.showProduct">
            <span>Produto: </span> {{ this.contract.product.name }}
          </div>
          <div *ngIf="
              this.account &&
              this.account.wallet &&
              this.account.wallet.automaticRecharge
            ">
            <span>Recarga automática: </span>R$
            {{ this.account.wallet.automaticRecharge.product.valueFormatted }}
          </div>
          <div *ngIf="this.contract && this.contract.code">
            <span>Pedido: </span>{{ this.contract.code }}
          </div>
          <div *ngIf="this.totalValue">
            <span>Valor: </span>{{ totalValue < 0 ? "0,00" : (totalValue | currency: "R$" ) }} </div>
              <div *ngIf="
              this.contract &&
              this.contract.endDate &&
              this.contract.nextRecurrenceDate
            ">
                <span>Data da próxima renovação: </span>{{ this.contract.nextRecurrenceDate }}
              </div>
              <div *ngIf="
              this.bankBilletData &&
              this.bankBilletData.expirationDate &&
              !this.bankBilletData.hideExpirationDate
            ">
                <span>Vencimento do boleto: </span>{{ this.bankBilletData.expirationDate }}
              </div>
          </div>

          <!-- Cartão de Crédito -->
          <div *ngIf="this.paymentMethod && this.paymentMethod === 'CREDIT_CARD'">
            <mat-divider inset></mat-divider>

            <div class="display-utils-row display-utils-center display-utils-gap-8">
              <div>
                <div class="display-utils-row display-utils-start-center display-utils-gap-8">
                  <div>
                    <div class="pme-credit-card-brand">
                      <div class="pme-payment-icon-{{
                        this.creditCardData.getBrandCSSMatching()
                      }}"></div>
                    </div>
                  </div>
                  <div>
                    <b>{{ this.creditCardData.getBrandName() }}</b><br />
                    {{ this.creditCardData.getFinalNumber() }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Boleto -->
          <div *ngIf="
            this.paymentMethod &&
            this.paymentMethod === 'BANK_BILLET' &&
            this.bankBilletData &&
            this.bankBilletData.status === 'EMITTED'
          ">
            <mat-divider inset></mat-divider>
            <div class="pme-bank-billet-info">
              <div>Código de barras para pagamento</div>
              <mat-form-field appearance="outline">
                <input matInput value="{{ this.bankBilletData.barcode }}" #inputTarget readonly />
                <button mat-icon-button matSuffix matTooltip="Copiar código" [ngxClipboard]="inputTarget"
                  (cbOnSuccess)="copied($event)">
                  <mat-icon>content_copy</mat-icon>
                </button>
                <button mat-icon-button matSuffix matTooltip="Baixar boleto" (click)="
                  openBankBilletOnNewTab(this.bankBilletData.bankBilletURL)
                ">
                  <mat-icon>get_app</mat-icon>
                </button>
              </mat-form-field>
              <div class="mat-small" *ngIf="!this.hideBankBilletMessage">
                O prazo de compensação do boleto é de até 3 dias úteis após o
                pagamento.
              </div>
            </div>
          </div>
          <div>
            <div class="pme-bank-billet-info" *ngIf="
              this.paymentMethod == 'BANK_BILLET' &&
              this.bankBilletData &&
              this.bankBilletData.status !== 'EMITTED'
            ">
              <mat-divider inset></mat-divider>
              <div>{{ this.bankBilletData.errorMsg }}</div>
            </div>
          </div>

          <!-- PIX -->
          <div *ngIf="this.paymentMethod && this.paymentMethod === 'PIX'">
            <mat-divider inset></mat-divider>

            <div class="pme-pix-info">
              <div *ngIf="this.pixData.chargedUser">
                <!-- SUCESSO INICIAL -->
                <div *ngIf="!this.timeExpired && !this.isPixPaid">
                  <div class="content-time">
                    <img class="icon-timer" src="/assets/images/icon-timer.svg" />
                    <p>
                      Esse código expira em
                      <b>
                        <iframe (load)="pixPaid()" src="about:blank" style="display: none;"></iframe>
                        <pme-timer-formatter [seconds]="this.expirationTime" (onTimerComplete)="changePage()"
                          (onStart)="pixPaid()">
                        </pme-timer-formatter>
                      </b>
                      minutos
                    </p>
                  </div>

                  <mat-card>
                    <mat-card-content>
                      <img src="data:image/png;base64,{{ this.pixData.file }}" />
                    </mat-card-content>
                  </mat-card>
                  <div>Copia e cola:</div>
                  <mat-form-field appearance="outline" class="pme-copy-paste">
                    <input matInput value="{{ this.pixData.qrCode }}" #inputTarget readonly />
                    <button mat-icon-button matSuffix matTooltip="Copiar código" [ngxClipboard]="inputTarget"
                      (cbOnSuccess)="copied($event)">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
                <!-- PIX EXPIRADO -->
                <div *ngIf="this.timeExpired">
                  <div class="pix-expired-header">
                    <div class="expired-warn-icon">
                      <img src="/assets/images/expired-warn.svg" />
                    </div>
                    <div class="expired-title">
                      <p id="expired">Código para pagamento expirou.</p>
                    </div>
                  </div>

                  <div class="pix-expired-text">
                    <p id="font-size-14-pix">
                      Para realizar o pagamento, gere um novo código Pix.
                    </p>
                  </div>

                  <div class="buttons">
                    <button mat-flat-button color="success" type="submit" [disabled]="submitting"
                      (click)="getPix2ndCopy()">
                      <div class="display-utils-row display-utils-center-center display-utils-gap-8">
                        <mat-spinner *ngIf="submitting" diameter="20" aria-label="Carregando"></mat-spinner>
                        <div>Gerar novo código</div>
                      </div>
                    </button>
                  </div>

                  <!-- importante -->
                  <div class="pme-alert-padding">
                    <pme-alert type="info" title="Importante!">
                      Se o pagamento não for confirmado em até 2 dias úteis, o
                      pedido será cancelado automaticamente.
                    </pme-alert>
                  </div>
                </div>

                <!-- PIX PAGO -->
                <div *ngIf="this.isPixPaid">
                  <div>
                    <p id="font-size-24">Pedido efetuado com sucesso!</p>
                    <p id="font-size-14" *ngIf="
                      contract.product.classificationIdentifier ===
                      'plano-mensal'
                    ">
                      <span>
                        R$
                        {{ pixData.totalValue.toString().split(".")[0] }},{{
                        pixData.totalValue.toString().split(".")[1]
                        }}
                        serão adicionados ao seus créditos.
                      </span>
                    </p>

                    <p id="font-size-14" *ngIf="
                      contract.product.classificationIdentifier !==
                      'plano-mensal'
                    ">
                      <span>
                        Você já pode usufruir do produto adquirido, basta clicar
                        no botão abaixo:
                      </span>
                    </p>

                    <div class="buttons display-utils-center">
                      <button mat-flat-button color="success" (click)="onSuccessButtonClick.emit()">
                        Acessar produtos <mat-icon>arrow_forward</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>


              </div>

              <!-- Tela de pix qnd vem sem os dados de pix -->
              <div *ngIf="!this.pixData.chargedUser">
                {{ this.pixData.errorMsg }}
              </div>
            </div>
          </div>

          <!-- Dados adicionais de recarga automatica -->
          <div *ngIf="
            this.contract &&
            this.contract.provisioningParameters &&
            this.contract.provisioningParameters.allowAutomaticRecharge &&
            this.contract.product.classificationIdentifier != 'lista-online'
          ">
            <mat-divider inset></mat-divider>

            <div>
              <div class="display-utils-row display-utils-center display-utils-gap-8">
                <div class="display-utils-row display-utils-start-center display-utils-gap-8">
                  <div class="pme-additional-info" id="additional-info"></div>
                </div>
              </div>
            </div>
          </div>
      </mat-card-content>

      <!-- MODAL 2 -->
      <mat-card-content *ngIf="this.modalParams.walletBalance">
        <div class="pme-order-info display-utils-col display-utils-gap-4">
          <div *ngIf="this.contract && this.contract.code">
            <span>Pedido: </span>{{ this.contract.code }}
          </div>
          <div>
            <span>Crédito: </span>{{ this.modalParams.walletBalance | currency: "R$" }}
          </div>
          <div *ngIf="this.contract && this.contract.saleDate">
            <span>Data da compra: </span>{{ this.contract.saleDate }}
          </div>
          <div *ngIf="this.bankBilletData">
            <span>Forma de pagamento: </span> Boleto
          </div>
          <div *ngIf="this.pixData"><span>Forma de pagamento: </span> PIX</div>
        </div>

        <!-- Cartão de crédito -->
        <div *ngIf="!this.bankBilletData && !this.pixData">
          <mat-divider inset></mat-divider>

          <div class="display-utils-row display-utils-center display-utils-gap-8">
            <div>
              <div class="display-utils-row display-utils-start-center display-utils-gap-8">
                <div>
                  <div class="pme-credit-card-brand">
                    <div class="pme-payment-icon-{{
                        this.creditCardData.getBrandCSSMatching()
                      }}"></div>
                  </div>
                </div>
                <div>
                  <b>{{ this.creditCardData.getBrandName() }}</b><br />
                  {{ this.creditCardData.getFinalNumber() }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>